import { createContext, useContext, useState } from "react";

import { torontoToday } from "@utils";

const today = () => torontoToday();

const DateContext = createContext();

export function DateProvider({ children }) {
  const [reportDate, setReportDate] = useState(today);
  return (
    <DateContext.Provider value={{ reportDate, setReportDate }}>{children}</DateContext.Provider>
  );
}

export function useReportDate() {
  const ctx = useContext(DateContext);
  if (!ctx) throw new Error("useReportDate must be used within <DateProvider>");
  return ctx;
}
